var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeShippingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 43,
    viewBox: "0 0 84 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5279 38.9008C73.7462 38.9008 75.2925 37.2198 75.2925 35.4499C75.2925 33.68 73.7462 31.999 71.5279 31.999C69.3096 31.999 67.7633 33.68 67.7633 35.4499C67.7633 37.2198 69.3096 38.9008 71.5279 38.9008ZM71.5279 42.038C75.3397 42.038 78.4297 39.0884 78.4297 35.4499C78.4297 31.8114 75.3397 28.8618 71.5279 28.8618C67.7161 28.8618 64.6261 31.8114 64.6261 35.4499C64.6261 39.0884 67.7161 42.038 71.5279 42.038Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2347 38.9008C30.453 38.9008 31.9993 37.2198 31.9993 35.4499C31.9993 33.68 30.453 31.999 28.2347 31.999C26.0164 31.999 24.4701 33.68 24.4701 35.4499C24.4701 37.2198 26.0164 38.9008 28.2347 38.9008ZM28.2347 42.038C32.0464 42.038 35.1365 39.0884 35.1365 35.4499C35.1365 31.8114 32.0464 28.8618 28.2347 28.8618C24.4229 28.8618 21.3329 31.8114 21.3329 35.4499C21.3329 39.0884 24.4229 42.038 28.2347 42.038Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3581 0C16.057 0 14.9716 0.994316 14.8579 2.29043L14.5635 5.64693H21.3332C22.0262 5.64693 22.588 6.20875 22.588 6.9018C22.588 7.59485 22.0262 8.15667 21.3332 8.15667H14.3433L14.1232 10.6664H18.8234C19.5165 10.6664 20.0783 11.2282 20.0783 11.9213C20.0783 12.6143 19.5165 13.1762 18.8234 13.1762H13.903L13.6829 15.6859H21.9606C22.6537 15.6859 23.2155 16.2477 23.2155 16.9408C23.2155 17.6338 22.6537 18.1957 21.9606 18.1957H13.4627L13.2426 20.7054H19.4509C20.1439 20.7054 20.7057 21.2672 20.7057 21.9603C20.7057 22.6533 20.1439 23.2151 19.4509 23.2151H13.0224L12.161 33.0348C12.0324 34.5018 13.1885 35.7639 14.6612 35.7639H20.0783C20.0783 31.2591 23.7302 27.6072 28.235 27.6072C32.7398 27.6072 36.3916 31.2591 36.3916 35.7639H57.3269H57.9748H63.3714C63.3714 31.2591 67.0233 27.6072 71.5281 27.6072C76.0329 27.6072 79.6848 31.2591 79.6848 35.7639H80.5088C81.8157 35.7639 82.9038 34.7609 83.0102 33.4583L83.9917 21.4347C84.0462 20.7672 83.8316 20.1056 83.3958 19.5972L75.4165 10.288C74.9397 9.7317 74.2436 9.41155 73.511 9.41155H64.2498C63.8192 9.41155 63.4048 9.30127 63.0409 9.10116L63.707 2.77248C63.863 1.29063 62.7011 0 61.2111 0H17.3581ZM65.2314 11.5835C65.244 11.4201 65.3803 11.2939 65.5442 11.2939H72.2335C72.5838 11.2939 72.9181 11.4402 73.1556 11.6976L79.8262 18.924C80.0117 19.125 79.8692 19.4505 79.5957 19.4505H64.9651C64.7823 19.4505 64.6383 19.295 64.6523 19.1128L65.2314 11.5835ZM33.9398 12.2074L34.1807 10.8672H28.0218L26.1696 21.3328H27.8863L28.6994 16.7099H32.1629L32.4038 15.3847H28.9404L29.4975 12.2074H33.9398ZM41.78 11.5749C41.2379 11.1031 40.4397 10.8672 39.3857 10.8672H35.7716L33.9194 21.3328H35.6361L36.374 17.1466H37.6991L39.3555 21.3328H41.4035L39.5814 16.996C40.4347 16.7952 41.1073 16.4137 41.5993 15.8516C42.1012 15.2894 42.4124 14.672 42.5329 13.9994C42.573 13.7383 42.5931 13.5426 42.5931 13.4121C42.5931 12.6592 42.3221 12.0468 41.78 11.5749ZM40.8162 13.5627C40.8162 13.7032 40.8012 13.8488 40.771 13.9994C40.6807 14.5515 40.4397 14.9882 40.0482 15.3095C39.6667 15.6307 39.1548 15.7913 38.5123 15.7913H36.6149L37.2474 12.2074H39.1447C39.7069 12.2074 40.1235 12.3279 40.3946 12.5688C40.6757 12.7997 40.8162 13.131 40.8162 13.5627ZM46.2047 15.3697L46.7618 12.1923H50.8276L51.0686 10.8521H45.2861L43.4339 21.3328H49.2164L49.4573 19.9926H45.3915L45.9788 16.6948H49.5928L49.8187 15.3697H46.2047ZM54.1016 15.3697L54.6587 12.1923H58.7245L58.9654 10.8521H53.183L51.3308 21.3328H57.1132L57.3542 19.9926H53.2884L53.8757 16.6948H57.4897L57.7156 15.3697H54.1016Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78411 3.13721C8.09106 3.13721 7.52924 3.69903 7.52924 4.39208C7.52924 5.08513 8.09106 5.64695 8.78411 5.64695H23.8426C24.5356 5.64695 25.0975 5.08513 25.0975 4.39208C25.0975 3.69903 24.5356 3.13721 23.8426 3.13721H8.78411ZM3.76462 8.1567C3.07157 8.1567 2.50975 8.71852 2.50975 9.41157C2.50975 10.1046 3.07157 10.6664 3.76462 10.6664H23.8426C24.5356 10.6664 25.0975 10.1046 25.0975 9.41157C25.0975 8.71852 24.5356 8.1567 23.8426 8.1567H3.76462ZM5.01949 14.4311C5.01949 13.738 5.58132 13.1762 6.27436 13.1762H23.8426C24.5356 13.1762 25.0975 13.738 25.0975 14.4311C25.0975 15.1241 24.5356 15.6859 23.8426 15.6859H6.27436C5.58132 15.6859 5.01949 15.1241 5.01949 14.4311ZM1.25487 18.1957C0.561826 18.1957 0 18.7575 0 19.4506C0 20.1436 0.561826 20.7054 1.25487 20.7054H23.8426C24.5356 20.7054 25.0975 20.1436 25.0975 19.4506C25.0975 18.7575 24.5356 18.1957 23.8426 18.1957H1.25487Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 71.5279,
    y1: 28.8618,
    x2: 71.5279,
    y2: 42.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F43435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 28.2347,
    y1: 28.8618,
    x2: 28.2347,
    y2: 42.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F43435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 19.8781,
    y1: 0.00000278752,
    x2: 83.0382,
    y2: 39.1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F43435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2.69907,
    y1: 3.13721,
    x2: 29.7948,
    y2: 13.3698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458015,
    stopColor: "#FF6364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651879,
    stopColor: "#FE5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE5C5D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeShippingIcon);
export default __webpack_public_path__ + "static/media/free_shipping_icon.d4e6b6d73efa9e8d46cd9c51a6a886c7.svg";
export { ForwardRef as ReactComponent };